// File: src/components/general/NotificationIcon/NotificationIcon.tsx
// Purpose: General UI component or utility

import React from "react";
import styled from "styled-components";
import { Bell } from "lucide-react";
import { Badge } from "../Badge";

interface NotificationIconProps {
  count?: number;
  icon?: React.ReactElement; // ✅ safer typing
  tooltipLabel?: string;
  size?: number;
  color?:string;
}

const NotificationWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const NotificationIcon: React.FC<NotificationIconProps> = ({
  count = 0,
  icon,
  tooltipLabel = "New notifications",
  size = 24,
  color
}) => {
  const finalIcon = icon || <Bell />;

  return (
    <NotificationWrapper title={tooltipLabel}>
      {React.cloneElement(finalIcon, { size, color })}
      <Badge count={count} color={color} />
    </NotificationWrapper>
  );
};